import React, { FC } from 'react';
import { Layout, Tooltip, Typography } from 'antd';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { GET_ORDERS_METRIX_SUMMARY } from '../../Apollo/graphql/Query';

const { Content } = Layout;

const SmallContainer = styled.div`
    /* width: fit-content; */
    border: 1px solid transparent;
    width: 350px;
    height: 200px;
    border-radius: 10px;
    background: white;
    display: flex;
    flex-direction: column;
    /* justify-content: center;
    align-items: center; */
    padding: 2rem;
`
interface Dprops {
    title: string;
    text: string;
    toolTipContent: string
}

const DashboardBox: FC<Dprops> = ({ title, text, toolTipContent, children }) => {
    return (
        <SmallContainer>
            <Tooltip title={toolTipContent}>
                <Typography.Title level={3}>{title}</Typography.Title>
                <Typography.Title style={{ textAlign: 'center' }}>{text}</Typography.Title>
                {children}
            </Tooltip>
        </SmallContainer>
    )
}


const AdminDashboard: FC = () => {

    const { data } = useQuery(GET_ORDERS_METRIX_SUMMARY);
    return (
        <>
            <Content>
                <div style={{ display: 'flex', flexFlow: 'row', gap: '1rem' }}>
                    <DashboardBox text={data?.ordersMetricsSummary?.totalSuccessfullOrders} title="Total Orders" toolTipContent="total orders " />
                    <DashboardBox text={data?.ordersMetricsSummary?.totalOrdersToday} title="Todays Orders" toolTipContent="todays orders" />
                </div>

            </Content>
        </>
    )
}

export default AdminDashboard;